<template>
  <v-row>
    <v-col>
      <v-row class="px-2 pt-2">
        <v-col>
          <v-expansion-panels>
            <v-expansion-panel v-test="{ panel: '' }">
              <v-expansion-panel-header>
                <div id="search">
                  <v-icon>
                    search
                  </v-icon>
                  {{ $t('Фильтры') }}
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager @keydown.native.enter="focusOnBtn('searchBtn')">
                <v-row class="px-3">
                  <v-col
                      class="pl-2"
                      cols="12"
                      md="5"
                      lg="4"
                      xl="3">
                    <validatable-text-input
                        v-model="params.userName"
                        :label="$t('Пользователь')"
                        hide-details
                        @keydown.native.enter="focusOnBtn('searchBtn')" />
                  </v-col>
                  <v-col
                      class="pl-2"
                      cols="12"
                      md="5"
                      lg="4"
                      xl="3">
                    <validatable-text-input
                        v-model="params.organization"
                        :label="$t('Организация')"
                        hide-details
                        @keydown.native.enter="focusOnBtn('searchBtn')" />
                  </v-col>
                  <v-col
                      class="pl-2"
                      cols="12"
                      md="5"
                      lg="4"
                      xl="3">
                    <custom-date-picker
                        v-model="params.tradeDataStart"
                        :label="$t('Дата начала торгов')"
                        @change="focusOnBtn('searchBtn')" />
                  </v-col>
                  <v-col class="text-right" align-self="center">
                    <btn-icon-tip
                        id="search"
                        ref="searchBtn"
                        icon="search"
                        icon-color="primary"
                        :tip="$t('Поиск')"
                        @click="search" />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <paginated-data-table
              v-if="getTradeRequests"
              ref="paginatedTable"
              :headers="headers1"
              :items="requests"
              :loading="isLoading"
              item-key="requestId"
              :total-count="totalCount"
              :items-per-page="itemsPerPage"
              single-expand
              show-expand
              :request-method="getTradeRequests">
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.requestDate="{ item }">
              {{ item.requestDate
                ? $moment(item.requestDate).format('DD.MM.YYYY HH:mm')
                : null }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.organizationName="{ item }">
              <route-link-with-tip
                  v-if="isAdmin"
                  :text="item.organizationName"
                  :tip="$t('Просмотр организации')"
                  :to="{ path: `${urlRootPath}/organization/${item.organizationId}` }" />
              <span v-else>
                {{ item.organizationName }}
              </span>
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.lotNumber="{ item }">
              <span>
                {{ item.lotNumber }}
              </span>
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.lotDescription="{ item }">
              <route-link-with-tip
                  v-if="!isRegistration"
                  :text="item.lotDescription"
                  :tip="$t('Просмотр торговой процедуры')"
                  :to="{ path: `${urlRootPath}/lot/${item.lotType}/${item.lotId}` }" />
              <span v-else>
                {{ item.lotDescription }}
              </span>
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.publicationDate="{ item }">
              {{ item.publicationDate
                ? $moment(item.publicationDate).format('DD.MM.YYYY HH:mm')
                : null }}
            </template>

            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <!-- <template v-slot:item.processDate="{ item }">
              {{ item.processDate
                ? $moment(item.processDate).format('DD.MM.YYYY HH:mm')
                : null }}
            </template> -->
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.requestId="{ item }">
              <route-btn-tip
                  :id="item.lotId"
                  :tip="tip"
                  :to="{ path: `${urlRootPath}/tradeRequest/process/${item.requestType}/${item.requestId}` }"
                  :icon="icon" />
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <v-row>
                  <v-col class="text-left">
                    <text-view
                        :display="item.lotType
                          ? $t(LOT_TYPE_ENUM[item.lotType])
                          : null"
                        :label="$t('Тип торговой процедуры')" />
                    <text-view
                        v-if="!inprocess && item.processComment"
                        :display="item.processComment"
                        :label="$t('Комментарий администратора')" />
                  </v-col>
                </v-row>
              </td>
            </template>
          </paginated-data-table>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import RouteLinkWithTip from '@/components/reused/ui/RouteLinkWithTip.vue'
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import TextView from '@/components/reused/ui/TextView.vue'
  import RouteBtnTip from '@/components/reused/ui/RouteBtnTip.vue'
  import PaginatedDataTable from '@/components/reused/ui/PaginatedDataTable.vue'
  import CustomDatePicker from '@/components/reused/ui/CustomDatePicker.vue'
  import { LOT_TYPE_ENUM } from '@/constants/enums'
  import { LOT_REQUEST_STATUSES, LOT_REQUEST_TYPES } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { TRADE_REQUEST_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      BtnIconTip,
      RouteLinkWithTip,
      RouteBtnTip,
      TextView,
      PaginatedDataTable,
      ValidatableTextInput,
      CustomDatePicker
    },
    props: {
      status: {
        type: String,
        required: true
      },
      requestType: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        LOT_TYPE_ENUM,
        isLoading: false,
        itemsPerPage: 10,
        params: {
          organization: '',
          tradeDataStart: '',
          userName: '',
          status: this.status
        }
      }
    },
    computed: {
      ...mapState(TRADE_REQUEST_MANAGEMENT.NAMESPACE, {
        requestsInfo: state => status => (state[TRADE_REQUEST_MANAGEMENT.STATE.REQUESTS][status] || {})
      }),
      isRegistration () {
        return this.requestType === LOT_REQUEST_TYPES.REGISTRATION
      },
      inprocess () {
        return (this.status === LOT_REQUEST_STATUSES.INPROCESS &&
          this.isAdmin)
      },
      icon () {
        if (this.inprocess) {
          return 'settings'
        }
        return 'visibility'
      },
      tip () {
        return this.showProcessDate
          ? this.$t('Просмотр запроса на регистрацию')
          : this.$t('Обработка запроса на регистрацию')
      },
      showProcessDate () {
        const statuses = [
          LOT_REQUEST_STATUSES.REJECTED,
          LOT_REQUEST_STATUSES.APPROVED
        ]
        return statuses.includes(this.status)
      },
      headers1 () {
        const headers =
          [
            { text: this.$t('Дата подачи запроса'), align: 'start', sortable: true, value: 'requestDate' },
            { text: this.$t('Организация'), align: 'start', sortable: false, value: 'organizationName' },
            { text: this.$t('№ торговой процедуры'), align: 'start', sortable: false, value: 'lotNumber' },
            { text: this.$t('Торговая процедура'), align: 'start', sortable: false, value: 'lotDescription' },
            { text: this.$t('Дата публикации'), align: 'start', sortable: false, value: 'publicationDate' },
            // { text: this.$t('Дата обработки запроса'), align: 'start', sortable: true, value: 'processDate' },
            { text: this.$t('Действия'), align: 'start', sortable: false, value: 'requestId' },
            { text: '', value: 'data-table-expand' }
          ]

        // if (!this.showProcessDate) {
        //   headers = headers.filter(h => h.value !== 'processDate')
        // }
        return headers
      },
      totalCount () {
        return this.requestsInfo(this.status).totalCount || 0
      },
      requests () {
        return this.requestsInfo(this.status).items || []
      }
    },
    watch: {
      status: {
        immediate: true,
        handler (newVal) {
          this.params.status = newVal
        }
      }
    },
    created () {
      this.clearStore()
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(TRADE_REQUEST_MANAGEMENT.NAMESPACE, {
        getTradeRequestsAction: TRADE_REQUEST_MANAGEMENT.ACTIONS.GET_TRADE_REQUESTS,
        clearTradeRequestsAction: TRADE_REQUEST_MANAGEMENT.ACTIONS.CLEAR_TRADE_REQUESTS
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearTradeRequestsAction(this.status)
          ])
      },
      search: async function () {
        await this.$refs.paginatedTable.resetPaginationAndGetDataFromServer()
      },
      getTradeRequests: async function (params) {
        try {
          this.isLoading = true
          await this.getTradeRequestsAction({
            requestType: this.requestType,
            params: {
              ...this.params,
              ...params
            }
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
